
import { Area, Coating, Commands, ComponentConstants, Credence, EntityDefaultPropertiesManager, Event, Events, eventsManager, KitchenTool, Listener, SceneConstants, WorkTop } from "@rhinov/savane-js";
import { EntityManager } from "../../cocos/scripts/plan/EntityManager";
import { ActionStateEnum } from "../../cocos/scripts/state/actionState/ActionState";
import { PlanManager } from "../../cocosPlan";
import { _ASSET_TYPE, getApiKey, getAsset, getAssets, getUrl } from "@rhinov/asset-manager-service";




export class WorktopController {
    refreshCallBack: () => void;
    coatingType: string =  _ASSET_TYPE.COATINGS;
    worktop: WorkTop | null = null;
    worktopCoating: Coating | null = null;
    worktopCredence: Credence | null = null;
    edge: number | null = null;
    edgeHasLeg: boolean = false;
    edgeHasCredence: boolean = false;
    worktopToConfigure: any | null = null;
    coatingsData: any = null;
    coatToUpdate: string | null = null;
    filterKFService: string = '';
    baseAssetUrl: string = getUrl();
    updateWorktoplistener: Listener | null = null;
    updateWorktopEdgelistener: Listener | null = null;
    credencesData: any;
    worktopsData: any;



    constructor(refreshCallBack: () => void) {
        this.refreshCallBack = refreshCallBack;

        /**
         * init available data for edition
         */
        getAssets(_ASSET_TYPE.COATINGS, '&q.hang.worktop.eq=true&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.manufacturer.in=662bb10916eb511a1c89d3ff,5be2c40c2e50ee46876e546d', (response: any) => {
            if (response.data.resources === undefined) {
                //toastr.error(err.data.message);
            }
            else {
                this.worktopsData = response.data.resources;
                this.refreshCallBack();
            }
        });

        /**
         * init available data for edition
         */
        getAssets(_ASSET_TYPE.COATINGS, '&q.hang.credence.eq=true&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.manufacturer.in=662bb10916eb511a1c89d3ff,5be2c40c2e50ee46876e546d', (response: any) => {
            if (response.data.resources === undefined) {
                //toastr.error(err.data.message);
            }
            else {
                this.credencesData = response.data.resources;
                this.refreshCallBack();
            }
        });

        getAsset(_ASSET_TYPE.COATINGS, EntityDefaultPropertiesManager.getInstance().kitchenDefaultCredenceCoating, getApiKey(), (resource: any) => {
            EntityDefaultPropertiesManager.getInstance().setWorktopDefaultCredence(resource, "1");
        });

        getAsset(_ASSET_TYPE.COATINGS, EntityDefaultPropertiesManager.getInstance().kitchenDefaultWorktopCoating, getApiKey(), (resource: any) => {
            EntityDefaultPropertiesManager.getInstance().setWorktopDefaultCoating(resource, "1");
        });

        this.updateWorktoplistener = eventsManager.instance.addListener(Events.SET_WORK_TOP, (event: Event) => {
            this.edge = null;
            if (this.worktop !== event.getUserData()) {
                this.coatToUpdate = null;
                this.worktop = event.getUserData();
                if (this.worktop !== null && this.worktop !== undefined) {
                    this.worktopCoating = this.worktop.getComponent(ComponentConstants.ComponentType.Coating) as Coating;
                    let credences = this.worktop.getComponents(ComponentConstants.ComponentType.Credence) as Array<Credence>;
                    let index = this.getCredenceIndex(this.edge, this.worktop);
                    for (let i = 0; i < credences.length; ++i) {
                        if (index === credences[i].credenceIndex) {
                            this.worktopCredence = credences[i];
                            break;
                        }
                    }
                }
                else {
                    this.worktop = null;
                    this.worktopCoating = null;
                    this.worktopCredence = null;
                    this.edge = null;
                    this.edgeHasLeg = false;
                    this.edgeHasCredence = false;
                    this.coatToUpdate = null;
                }
            }
            this.refreshCallBack();
        });

        this.updateWorktopEdgelistener = eventsManager.instance.addListener(Events.SET_WORK_TOP_EDGE, (event: Event) => {
            if (this.edge !== event.getUserData()) {
                this.edge = event.getUserData();
                this.edgeHasLeg = false;
                this.edgeHasCredence = false;

                if (this.worktop) {
                    let credences = this.worktop.getComponents(ComponentConstants.ComponentType.Credence) as Array<Credence>;
                    let index = this.getCredenceIndex(this.edge, this.worktop);
                    for (let i = 0; i < credences.length; ++i) {
                        if (index === credences[i].credenceIndex) {
                            this.worktopCredence = credences[i];
                            break;
                        }
                    }
                }

                if (this.worktop !== null && this.edge !== null) {
                    let legs = this.worktop.legs;
                    let credences = this.worktop.credences;
                    let area = this.worktop.getComponent(ComponentConstants.ComponentType.Area) as Area;
                    let testBeginIdx = this.edge;
                    let testEndIdx = (this.edge + 1) % area!.vertices.length;
                    for (let i = 0; i < legs.length; i++) {
                        if (legs[i].areaBeginIndex === testBeginIdx && legs[i].areaEndIndex === testEndIdx) {
                            this.edgeHasLeg = true;
                            break;
                        }
                    }
                    for (let i = 0; i < credences.length; i++) {
                        if (credences[i].areaBeginIndex === testBeginIdx && credences[i].areaEndIndex === testEndIdx) {
                            this.edgeHasCredence = true;
                            break;
                        }
                    }
                }
            }
            this.refreshCallBack();
        });
    }


    toogleLeg() {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        eventsManager.instance.dispatch(Events.TOOGLE_WORK_TOP_LEG, {
            isUnder: false
        });
        this.edgeHasLeg = !this.edgeHasLeg;
        PlanManager.getInstance().saveInCache();
    };

    toogleCredence() {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        eventsManager.instance.dispatch(Events.TOOGLE_WORK_TOP_CREDENCE, {});
        this.edgeHasCredence = !this.edgeHasCredence;
        PlanManager.getInstance().saveInCache();
    };

    getsetCredenceHeight(value: number): number {
            if (arguments.length === 0 || value === undefined) {
                // getter
                if (this.edge === null) {
                    return(this.worktop!.credenceHeightCm!)
                }
                else {
                    let area = this.worktop!.getComponent(ComponentConstants.ComponentType.Area) as Area;
                    let testBeginIdx = this.edge;
                    let testEndIdx = (this.edge + 1) % area.vertices.length;
                    let i: number;
                    for (i = 0; i < this.worktop!.credences.length; i++) {
                        if (this.worktop!.credences[i].areaBeginIndex === testBeginIdx && this.worktop!.credences[i].areaEndIndex === testEndIdx) {
                            break;
                        }
                    }

                    if (i < this.worktop!.credences.length) {
                        return(this.worktop!.credences[i].height / 10);
                    } else {
                        return 0;
                    }
                }
            } else {
                // setter
                if (this.edge === null) {
                    this.worktop!.credenceHeightCm = value;
                    for (let i = 0 ; i < this.worktop!.credences.length ; i++) {
                        this.worktop!.credences[i].height = value * 10;
                    }
                }
                else {
                    let area = this.worktop!.getComponent(ComponentConstants.ComponentType.Area) as Area;
                    let testBeginIdx = this.edge;
                    let testEndIdx = (this.edge + 1) % area.vertices.length;
                    let i: number;
                    for (i = 0; i < this.worktop!.credences.length; i++) {
                        if (this.worktop!.credences[i].areaBeginIndex === testBeginIdx && this.worktop!.credences[i].areaEndIndex === testEndIdx) {
                            break;
                        }
                    }

                    if (i < this.worktop!.credences.length) {
                        this.worktop!.credences[i].height = value * 10;
                    }
                }
                return value;
            }
    };

    openCoating(type: string) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        this.coatToUpdate = type;
        switch (type) {
            case 'credences':
                this.coatingsData = this.credencesData;
                break;

            default:
                this.coatingsData = this.worktopsData;
        }
    };

    applyOffset(dX: number, dY: number) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        if (this.worktopCredence) {
            this.worktopCredence.offset[0] += dX / 100;
            if (this.worktopCredence.offset[0] < 0) {
                this.worktopCredence.offset[0] = 0;
            }
            if (this.worktopCredence.offset[0] > 1) {
                this.worktopCredence.offset[0] = 1;
            }
            this.worktopCredence.offset[1] += dY / 100;
            if (this.worktopCredence.offset[1] < 0) {
                this.worktopCredence.offset[1] = 0;
            }
            if (this.worktopCredence.offset[1] > 1) {
                this.worktopCredence.offset[1] = 1;
            }
        }
        eventsManager.instance.dispatch(Events.COATING_ROTATION_CHANGED, this.worktopCredence);
    };



    openConfig(worktopCoatingRessource: any) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        if (this.worktopToConfigure !== null &&
            this.worktopToConfigure._id === worktopCoatingRessource._id) {
            this.worktopToConfigure = null;
        }
        else {
            this.worktopToConfigure = worktopCoatingRessource;
        }
    };

    closeConfig() {
        this.coatToUpdate = null;
        this.worktopToConfigure = null;
    }

    updateCoating(worktopCoatingRessource: any, configId: number) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        let objectUpdated = null;
        if (this.coatToUpdate === 'coatings') {
            if (worktopCoatingRessource.colors) {
                objectUpdated = new Coating(worktopCoatingRessource._id, worktopCoatingRessource.manufacturer, worktopCoatingRessource.retailer, 0, [worktopCoatingRessource.colors], worktopCoatingRessource.randomization, worktopCoatingRessource.floorGeneratorSettings ?? '', undefined as any);
            }
            else {
                objectUpdated = new Coating(worktopCoatingRessource._id, worktopCoatingRessource.manufacturer, worktopCoatingRessource.retailer, 0, worktopCoatingRessource.configs, worktopCoatingRessource.randomization, worktopCoatingRessource.floorGeneratorSettings ?? '', undefined as any);
            }
            (objectUpdated as any)._colorIndex = configId;
            eventsManager.instance.dispatch(Events.UPDATE_WORK_TOP_COATING, {
                coating: objectUpdated,
                credence: null
            });
            this.worktopCoating = this.worktop!.getComponent(ComponentConstants.ComponentType.Coating) as Coating;
        }
        else {
            let credenceIndex: number | null = null;
            if (this.edge !== null) {
                let area = this.worktop!.getComponent(ComponentConstants.ComponentType.Area) as Area;
                let beginIdx = this.edge;
                let endIdx = (this.edge + 1) % area.vertices.length;
                for (let i = 0; i < this.worktop!.credences.length; i++) {
                    if (this.worktop!.credences[i].areaBeginIndex === beginIdx &&
                        this.worktop!.credences[i].areaEndIndex === endIdx) {
                        credenceIndex = i;
                        break;
                    }
                }
            }

            if (this.worktopCredence) {
                if (worktopCoatingRessource.colors) {
                    objectUpdated = new Credence(worktopCoatingRessource._id, worktopCoatingRessource.manufacturer, worktopCoatingRessource.retailer, 0, [worktopCoatingRessource.colors], worktopCoatingRessource.randomization, this.worktopCredence.height, credenceIndex!);
                }
                else {
                    objectUpdated = new Credence(worktopCoatingRessource._id, worktopCoatingRessource.manufacturer, worktopCoatingRessource.retailer, 0, worktopCoatingRessource.configs, worktopCoatingRessource.randomization, this.worktopCredence.height, credenceIndex!);
                }
            }
            else {
                if (worktopCoatingRessource.colors) {
                    objectUpdated = new Credence(worktopCoatingRessource._id, worktopCoatingRessource.manufacturer, worktopCoatingRessource.retailer, 0, [worktopCoatingRessource.colors], worktopCoatingRessource.randomization, 600, credenceIndex!);
                }
                else {
                    objectUpdated = new Credence(worktopCoatingRessource._id, worktopCoatingRessource.manufacturer, worktopCoatingRessource.retailer, 0, worktopCoatingRessource.configs, worktopCoatingRessource.randomization, 600, credenceIndex!);
                }
            }
            (objectUpdated as any)._colorIndex = configId;
            eventsManager.instance.dispatch(Events.UPDATE_WORK_TOP_COATING, {
                credence: objectUpdated,
                credenceIndex: credenceIndex,
                coating: null
            });
            //this.worktopCredenceResource = worktopCoatingRessource;
            let credences = this.worktop!.getComponents(ComponentConstants.ComponentType.Credence) as Credence[];
            let index = this.getCredenceIndex(this.edge, this.worktop!);
            for (let i = 0; i < credences.length; ++i) {
                if (index === credences[i].credenceIndex as number) {
                    this.worktopCredence = credences[i];
                    break;
                }
            }
        }

        //this.coatToUpdate = null;
        //this.worktopToConfigure = null;

        eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);

        PlanManager.getInstance().saveInCache();
    };

    isCurrentWorktopCoating(coating: any): boolean {
        if (!this.worktop) {
            return(false);
        }

        let currCoating = null;
        if (this.coatToUpdate === 'coatings') {
            currCoating = this.worktop.getComponent(ComponentConstants.ComponentType.Coating) as Coating;
        }
        else {
            let credences = this.worktop.getComponents(ComponentConstants.ComponentType.Credence) as Credence[];
            let index = this.getCredenceIndex(this.edge, this.worktop);
            for (let i = 0; i < credences.length; ++i) {
                if (index === credences[i].credenceIndex) {
                    currCoating = credences[i];
                    break;
                }
            }
        }

        if (currCoating) {
            return (currCoating as any)._coatingId === coating._id;
        } else {
            return false;
        }
    };

    isCurrentWorktopOtherCoating(coating: any): boolean {
        if (!this.worktop) {
            return(false);
        }

        let currCoatingName: string;
        let currCoating: Credence | Coating;
        if (this.coatToUpdate === 'coatings') {
            currCoating = this.worktop.getComponent(ComponentConstants.ComponentType.Credence) as Credence;
            if (!currCoating) return false
            let idx = this.credencesData.findIndex((coatingRessource: any) => coatingRessource._id === currCoating.coatingId);
            if (idx === -1) {
                return(false);
            }
            currCoatingName = this.credencesData[idx].name;
        }
        else {
            currCoating = this.worktop.getComponent(ComponentConstants.ComponentType.Coating) as Coating;
            if (!currCoating) return false;
            let idx = this.worktopsData.findIndex((coatingRessource: any) => coatingRessource._id === currCoating.coatingId);
            if (idx === -1) {
                return(false);
            }
            currCoatingName = this.worktopsData[idx].name;
        }

        let resName = coating.name;

        let resNameArray = resName.split("-");
        let currCoatingNameArray = currCoatingName.split("-");

        let idx1 = resNameArray.indexOf('TRAVAIL');
        if (idx1 === -1) {
            idx1 = resNameArray.indexOf('CREDENCE');
        }
        if (idx1 === -1)
        {
            return(false);
        }
        let idx2 = currCoatingNameArray.indexOf('TRAVAIL');
        if (idx2 === -1) {
            idx2 = currCoatingNameArray.indexOf('CREDENCE');
        }
        if (idx2 === -1)
        {
            return(false);
        }
        idx1++;
        idx2++;

        if (resNameArray.length - idx1 !== currCoatingNameArray.length - idx2) {
            return(false);
        }

        for ( ; idx1 < resNameArray.length ; idx1++, idx2++) {
            if (resNameArray[idx1] !== currCoatingNameArray[idx2]) {
                return(false);
            }
        }

        return(true);
    };

    removeAllWorktop() {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        let worktops = PlanManager.getInstance().world.currentScene!.getChildren([SceneConstants.EntityType.WorkTop]);
        PlanManager.getInstance().executeCommand(new Commands.DeleteEntitiesCommand(worktops));

        PlanManager.getInstance().saveInCache();
    };

    removeAllCredences() {
        if (this.worktop) {
            let params = [];
            let area = this.worktop.getComponent(ComponentConstants.ComponentType.Area);
            if (area) {
                eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
                for (let i = this.worktop.credences.length - 1 ; i >= 0 ; i--) {
                    params.push({deletedCredence: i});
                }
                PlanManager.getInstance().executeCommand(new Commands.EditComponentCommand(area, params));
            }
            this.edgeHasCredence = false;
        }
    };

    regenerateHull() {
        eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);
    };

    generateWorktops() {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        //Clear nodes before
        let worktops = PlanManager.getInstance().world.currentScene!.getChildren([SceneConstants.EntityType.WorkTop]);
        for (let i = 0; i < worktops.length; i++) {
            EntityManager.getInstance().removeEntity(worktops[i]);
        }
        //Execute fuse and generation
        KitchenTool.KitchenManager.generateKitchenWorktopAndFuse(PlanManager.getInstance().world.currentScene!.currentFloor,
            EntityDefaultPropertiesManager.getInstance().coating,
            EntityDefaultPropertiesManager.getInstance().credence
        );
        //Recreate entities
        worktops = PlanManager.getInstance().world.currentScene!.getChildren([SceneConstants.EntityType.WorkTop]);
        for (let i = 0; i < worktops.length; i++) {
            EntityManager.getInstance().addEntity(worktops[i]);
        }

        eventsManager.instance.dispatch(Events.PROJECT_REFRESH_HULL);

        PlanManager.getInstance().saveInCache();
    };

    setWorktopMode() {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        let instance = PlanManager.getInstance();

        if (instance !== null && instance !== undefined) {
            if (instance.getAction() === ActionStateEnum.DrawWorkTop) {
                instance.changeState(ActionStateEnum.idleDecoration);
            }
            else {
                instance.changeState(ActionStateEnum.DrawWorkTop);
            }
            eventsManager.instance.dispatch(Events.FULLSCREEN_CHANGED);
        }
    };

    DestroyWorktop(){
        eventsManager.instance.removeListener(this.updateWorktoplistener!);
        eventsManager.instance.removeListener(this.updateWorktopEdgelistener!);
    };

    getCredenceIndex(edge: number | null, worktop: WorkTop): number | null {
        if (edge === null || edge === undefined) return null;

        let area = worktop.getComponent(ComponentConstants.ComponentType.Area) as Area;
        let beginIdx = edge;
        let endIdx = (edge + 1) % area.vertices.length;
        for (let i = 0; i < worktop.credences.length; i++) {
            if (worktop.credences[i].areaBeginIndex === beginIdx &&
                worktop.credences[i].areaEndIndex === endIdx) {
                return i;
            }
        }
        return null;
    };
}
